// this formik state helps to determine which fields are rendered in DOM
// the main idea of usage is to determine if fields needed to be validated or not
// additionally used to represent BE server errors
export const RENDERED_FIELDS = 'renderedFields'

export const URL_FORM_PARAMS = {
  FORM_NAME: 'form',
  ITEM_ID: 'itemId'
}

// RADIO OPTIONS
export const OPTION_CUSTOM = 'option_custom'
export const OPTION_YES = 'option_yes'
export const OPTION_NO = 'option_no'

// these constants used both for redux and query params in URL for create/edit state
// (don't remove or change next line) as it is used as regex pattern in plop.js:
// PLOP_APPEND_PATTERN_ANCHOR

// these constants used both for redux and query params in URL for create/edit state
export const CAMPAIGN_FACEBOOK_CREATE = 'campaignFacebookCreate'
export const CAMPAIGN_GOOGLE_CREATE = 'campaignGoogleCreate'
export const CAMPAIGN_FACEBOOK_EDIT = 'campaignFacebookEdit'
export const CAMPAIGN_GOOGLE_EDIT = 'campaignGoogleEdit'
export const CAMPAIGN_FACEBOOK_DUPLICATE = 'campaignFacebookDuplicate'
export const CAMPAIGN_GOOGLE_ADS_CREATE = 'campaignGoogleAdsCreate'
export const CAMPAIGN_TIKTOK_CREATE = 'campaignTikTokCreate'
export const CAMPAIGN_TIKTOK_EDIT = 'campaignTikTokEdit'
export const CAMPAIGN_DV360_CREATE = 'campaignDv360Create'
export const CAMPAIGN_DV360_EDIT = 'campaignDv360Edit'
export const COMBINED_CAMPAIGN_EDIT = 'combinedCampaignEdit'

// LINE ITEMS:
export const LINE_ITEM_FACEBOOK_CREATE = 'lineItemFacebookCreate'
export const LINE_ITEM_FACEBOOK_EDIT = 'lineItemFacebookEdit'
export const LINE_ITEM_FACEBOOK_DUPLICATE = 'lineItemFacebookDuplicate'
export const LINE_ITEM_GOOGLE_ADS_CREATE = 'lineItemGoogleAdsCreate'
export const LINE_ITEM_GOOGLE_EDIT = 'lineItemGoogleEdit'
export const LINE_ITEM_TIKTOK_CREATE = 'lineItemTiktokCreate'
export const LINE_ITEM_TIKTOK_EDIT = 'lineItemTikTokEdit'
export const LINE_ITEM_DV360_CREATE = 'lineItemDv360Create'
export const LINE_ITEM_DV360_EDIT = 'lineItemDv360Edit'

// ADS
export const AD_FACEBOOK_CREATE = 'adFacebookCreate'
export const AD_FACEBOOK_EDIT = 'adFacebookEdit'
export const AD_GOOGLE_CREATE = 'adGoogleCreate'
export const AD_GOOGLE_EDIT = 'adGoogleEdit'
export const ASSET_GROUP_GOOGLE_ADS_CREATE = 'performanceMaxAdCreate'
export const ASSET_GROUP_GOOGLE_ADS_EDIT = 'performanceMaxAdEdit'
export const AD_TIKTOK_CREATE = 'adTikTokCreate'
export const AD_TIK_TOK_EDIT = 'adTikTokEdit'
export const DISAPPROVE_INTERNAL_AD = 'disapproveInternalAd'
export const AD_DV360_CREATE = 'adDv360Create'
export const AD_DV360_EDIT = 'adDv360Edit'
export const AD_GAM_CREATE = 'adGamCreate'

export const AUDIENCE_CREATE = 'audienceCreate'
// CALENDAR PLANNER
export const PLANNER_EVENT_GROUP_CREATE = 'plannerEventGroupCreate'
export const PLANNER_EVENT_GROUP_EDIT = 'plannerEventGroupEdit'
export const PLANNER_EVENT_CREATE = 'plannerEventCreate'
export const PLANNER_EVENT_EDIT = 'plannerEventEdit'
export const PLANNER_GROUP_EDIT = 'plannerEventGroupEdit'
// LOCATION LIST
export const LOCATION_LIST_CREATE = 'locationListCreate'
export const LOCATION_LIST_EDIT = 'locationListEdit'
// TEAM MEMBERS
export const MEMBER_CHANGE_ROLE = 'MEMBER_CHANGE_ROLE'
export const MEMBER_CHANGE_STATUS = 'MEMBER_CHANGE_STATUS'
export const TEAM_MEMBER_CREATE = 'teamMemberCreate'
// CLIENT ACCOUNTS
export const CLIENT_ACCOUNT_CREATE = 'clientAccountCreate'
export const CLIENT_ACCOUNT_EDIT = 'clientAccountEdit'
// RIGHTS
export const RIGHT_CREATE = 'rightCreate'
export const RIGHT_EDIT = 'rightEdit'
export const RIGHT_MANAGE_FILES = 'manageRightFiles'
export const DIGITAL_RIGHT_CREATE = 'digitalRightCreate'
export const POST_RIGHT_CREATE = 'postRightCreate'
export const COMBINED_FACEBOOK_TIKTOK_CREATE = 'combinedFacebookTiktokCreate'

// SELECTOR
export const SELECTOR_SCORE_CARD = 'scoreCard'
export const UPDATE_SELECTOR = 'updateSelector'
// PARTNERSHIP
export const PARTNERSHIP_CREATE = 'partnershipCreate'
export const PARTNERSHIP_EDIT = 'partnershipEdit'
// PARTNER ACCOUNTS
export const PARTNER_ACCOUNT_CREATE = 'partnerAccountCreate'
export const PARTNER_ACCOUNT_EDIT = 'partnerAccountEdit'
// SOCIAL PAGES
export const ACCESSIBLE_SOCIAL_PAGE_ADD_FACEBOOK = 'accessiblePageAddFacebook'
export const ACCESSIBLE_SOCIAL_PAGE_ADD_TIKTOK = 'accessiblePageAddTikTok'
export const REQUEST_FACEBOOK_PAGE_ACCESS = 'requestFacebookPageAccess'
// RIGHT SUMMARY PAGE FORMS
export const UPLOAD_FACEBOOK_AD_CREATIVE = 'uploadFacebookAdCreative'
export const UPLOAD_CREATIVE_CAMPAIGN_CREATE = 'uploadCreativeCampaignCreate'
export const UPLOAD_CREATIVE_GOOGLE_LANGUAGES = 'uploadCreativeGoogleLanguages'
export const UPLOAD_GOOGLE_AD_CREATIVE = 'uploadGoogleAdCreative'
export const UPLOAD_TIKTOK_AD_CREATIVE = 'uploadTikTokAdCreative'
export const UPLOAD_DV360_AD_CREATIVE = 'uploadDV360AdCreative'
export const UPLOAD_GAM_AD_CREATIVE = 'uploadGamAdCreative'
// MARGIN
export const MARGIN_CREATE = 'margin_create'
// AD SERVER
export const AD_SERVER_ACCESS_CREATE = 'ad_server_access_create'
export const AD_SERVER_ACCESS_UPDATE = 'ad_server_access_update'

export const REPORT_FACEBOOK_CREATE = 'reportFacebookCreate'
export const REPORT_FACEBOOK_EDIT = 'reportFacebookEdit'

export const PARTNERBRAIN_OPTIMISATIONS = 'partnerbrainOptimisations'

export const BOOST_ORGANIC_POST = 'boostOrganicPost'

// OTHER DRAWERS:
export const CHANGE_CAMPAIGN_HISTORY = 'changeCampaignHistory'
export const CHANGE_LINE_ITEM_HISTORY = 'changeLineItemHistory'
export const CHANGE_ADS_HISTORY = 'changeAdsHistory'
export const CHANGE_ASSET_GROUP_HISTORY = 'changeAssetGroupHistory'
export const SROI_REPORT_PAYLOAD_CREATE = 'sroiReportPayloadCreate'
export const SROI_REPORT_PAYLOAD_EDIT = 'sroiReportPayloadEdit'
export const SROI_INPUTS_PRESET_EDIT = 'sroiInputsPresetEdit'
export const EXPORT_AS_CSV_REPORT = 'exportAsCsvReport'

export const SPONSOR_INFO_FORM = 'sponsorInfoForm'
export const INVENTORY_BREAKDOWN_AND_REQUIRED_CREATIVES = 'inventoryBreakdownAndRequiredCreatives'

export const AUDIENCE_SUGGESTION_TYPE = {
  WEBSITE_ALL_VISITORS: 'websiteAllVisitors',
  WEBSITE_TOP_25: 'websiteTop25',
  FACEBOOK_PAGE_ENGAGERS: 'facebookPageEngagers'
}
